export { AdvertisingSlotConfigType } from '@foundation-player/runtime';
export type {
  AdBumperClip,
  AdvertisingConfig,
  LinearAdvertisingSlotConfig,
  NonLinearAdvertisingSlotConfig,
} from '@foundation-player/types';
